// extracted by mini-css-extract-plugin
export default {"content":"EditMaterialWarehousing_content__kh309","remain":"EditMaterialWarehousing_remain__lTMn7"};